import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'react-modal';
import ReportVehicles from './ReportWorkFlowVehicles';
import { getReportVehicles } from '../../actions/apiGetInfo';
import { setReportVehicles } from '../../actions/apiSetInfo';
import LoadingSpinner from '../../components/LoadingSpinner/loadingSpinner';

const ReportWorkFlowVehiclesModal = ({ report_id: initialReportId, department_id: initialDepartmentId }) => {
  const dispatch = useDispatch();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [report_id, setReportId] = useState(initialReportId);
  const [department_id, setDepartmentId] = useState(initialDepartmentId);
  const [loading, setLoading] = useState(false);
  const report_vehicles = useSelector(state => state.settings_reports.report_vehicles || []);

  useEffect(() => {
    // console.log('ReportWorkFlowVehiclesModal: Updating props:', { initialReportId, initialDepartmentId });
    setReportId(initialReportId);
    setDepartmentId(initialDepartmentId);
  }, [initialReportId, initialDepartmentId]);

  useEffect(() => {
    if (loading) {
      // console.log('ReportWorkFlowVehiclesModal: Loading vehicles:', { report_id, report_vehicles });
      if (report_vehicles) {
        // console.log('ReportWorkFlowVehiclesModal: Vehicles loaded:', { report_id, department_id, report_vehicles });
        setLoading(false);
        setModalIsOpen(true);
      }
    }
  }, [report_vehicles, loading, report_id, department_id]);

  const openModal = (newReportId, newDepartmentId) => {
    if (newReportId > 0) {
      // console.log('ReportWorkFlowVehiclesModal: Opening modal with:', { newReportId, newDepartmentId });
      setReportId(newReportId);
      setDepartmentId(newDepartmentId);
      setLoading(true);
      dispatch(getReportVehicles(newReportId)).then(response => {
        // console.log('ReportWorkFlowVehiclesModal: getReportVehicles response:', { reportId: newReportId, response });
        setLoading(false);
        setModalIsOpen(true);
      }).catch(error => {
        // console.error('ReportWorkFlowVehiclesModal: Error fetching vehicles:', { reportId: newReportId, error });
        setLoading(false);
        setModalIsOpen(true);
      });
    } else {
      // console.warn('ReportWorkFlowVehiclesModal: Invalid report_id:', newReportId);
      setModalIsOpen(false);
    }
  };

  const closeModal = () => {
    // console.log('ReportWorkFlowVehiclesModal: Closing modal');
    setModalIsOpen(false);
    setLoading(false);
    dispatch(setReportVehicles([]));
  };

  return (
    <div className="col-md-3">
      <div className="btn-group">
        <button
          className="btn btn-large btn-success btn-block"
          onClick={() => {
            // console.log('ReportWorkFlowVehiclesModal: Button clicked:', { initialReportId, initialDepartmentId });
            openModal(initialReportId, initialDepartmentId);
          }}
          disabled={loading}
        >
          <i className="fal fa-car" />
        </button>
      </div>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={() => console.log('ReportWorkFlowVehiclesModal: Modal opened')}
        onRequestClose={closeModal}
        contentLabel="Report Vehicles"
        className="customModal"
        ariaHideApp={false}
        overlayClassName="report-overlay"
      >
        <div className="customCard">
          <div className="customHeader">
            <button
              type="button"
              className="btn btn-danger btn-sm float-end space-left-2"
              aria-label="Close"
              onClick={closeModal}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="customContent">
            {(!report_vehicles || report_vehicles.length === 0) && !loading ? (
              <div className="text-center" style={{ padding: '20px', fontSize: '1rem', color: '#666' }}>
               <LoadingSpinner loading />
              </div>
            ) : (
              <ReportVehicles report_id={report_id} department_id={department_id} work_flow_id={department_id} />
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ReportWorkFlowVehiclesModal;